export default class YoutubeLink {

    constructor($view) {

        this.$view = $view;
        this.bind();

    }

    bind(){
        // On ne charge pas les actions si on est en mode edition dans le content-builder
        if($('.display-content').length){
            this.bindFront();
            this.handleIconDisplay();
        }
    }

    bindFront(){

        // Au clic sur l'icone du lecteur
        this.$view.on('click','.gh-icon-play', (e) => {
            this.$view.find('a img').click();
        });

        // Au clic sur l'image
        this.$view.on('click','a img' ,(e) => {
            e.preventDefault();
            let $link = this.$view.find('a');
            if($link.length){
                let url = '/load-video-modal?lien='+ $link.attr('href');
                HegydCore.initRemoteModal('#modal',url);
            }
        });
    }

    // On affiche l'icone si l'image a bien un lien
    handleIconDisplay(){
        let $link = this.$view.find('a');
        if($link.length){
            this.$view.find('.gh-icon-play').css('display','flex');
        }
    }
}